var BlockView = require('views/block/base-block-view');
var HTML5GameService = require('services/game-service');

// HTML5GameView now assumes the following parameters to be given in the block settings:
// gameId: the id to be given to the div containing the html5 game.
// height: the height of the game (internally, as there are scale handlers present on the div containing the canvas)
// width: same as above but for the width
// menuBarOffset:  the size in pixels of the top menubar
// actionBarOffset: the size in pixels of the bottom actionbar
// gamePath: path to the game logic files


var HTML5GameView = BlockView.extend({
  load: function() {
    var self = this;

    var gameId = this.model.get('id');
    if(gameId === undefined) {
      gameId = 'html5game';
    }
    var height = this.model.get('height');
    if(height === undefined) {
      height = 720;
    } else {
      height = parseInt(height, 10);
    }

    var width = this.model.get('width');
    if(width === undefined) {
      width = 1280;
    } else {
      width = parseInt(width, 10);
    }

    var menuBarOffset = this.model.get('menuBarOffset');
    if(menuBarOffset === undefined) {
      menuBarOffset = 60;
    } else {
      menuBarOffset = parseInt(menuBarOffset, 10);
    }

    var actionBarOffset = this.model.get('actionBarOffset');
    if(actionBarOffset === undefined) {
      actionBarOffset = 60;
    } else {
      actionBarOffset = parseInt(actionBarOffset, 10);
    }

    var gameScriptsPath = this.model.get('gameScriptsPath');
    if(gameScriptsPath === undefined) {
      gameScriptsPath = '';
    }

    var callbacks = {
      end: function() {
        self.readyToGo();
      }
    };
    this.game = HTML5GameService.initPhaserGame(
      {
        gameId:gameId,
        width:width,
        height:height,
        menuBarOffset:menuBarOffset,
        actionBarOffset:actionBarOffset,
        gameScriptsPath: gameScriptsPath
      },
      callbacks);
  },
  dispose: function() {
    if(this.game) {
      this.game.destroy();
      // clearing out TGA namespace on dispose
      //if(window.TGA){
       // window.TGA = {};
      //}
    }
    BlockView.prototype.dispose.apply(this, arguments);
  }
});

module.exports = HTML5GameView;
